import React from 'react';
import { History, Eye, RefreshCw, FileText, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

const ICON_BTN_STYLE = {
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  padding: '4px',
  borderRadius: '6px',
  display: 'flex',
  alignItems: 'center',
};

const EmailHistoryCard = ({
  emailHistory,
  onViewStats,
  onReuse,
  onSaveAsTemplate,
  onDelete,
}) => (
  <Card className="history-card">
    <CardHeader>
      <CardTitle className="email-card-title">
        <History size={20} />
        Recent Emails
      </CardTitle>
    </CardHeader>
    <CardContent>
      {emailHistory.length === 0 ? (
        <p className="no-history">No emails sent yet.</p>
      ) : (
        <div className="history-list">
          {emailHistory.slice(0, 5).map((item) => (
            <div
              key={item.id}
              className="history-item clickable"
              onClick={() => onViewStats(item.id)}
              style={{ position: 'relative' }}
            >
              <div className="history-subject">{item.subject}</div>
              <div className="history-meta">
                <span>{item.recipient_count} sent</span>
                {(item.opens > 0 || item.unique_opens > 0) && (
                  <span className="history-opens">
                    <Eye size={12} /> {item.unique_opens || (item.opened_by || []).length}
                  </span>
                )}
                <span className={`history-status ${item.status}`}>{item.status}</span>
                <div style={{ marginLeft: 'auto', display: 'flex', gap: '2px', alignItems: 'center' }}>
                  <button
                    type="button"
                    onClick={(e) => onReuse(item, e)}
                    title="Load into composer to edit & resend"
                    data-testid={`reuse-email-${item.id}`}
                    style={{ ...ICON_BTN_STYLE, color: '#FFD700' }}
                  >
                    <RefreshCw size={14} />
                  </button>
                  <button
                    type="button"
                    onClick={(e) => onSaveAsTemplate(item, e)}
                    title="Save as reusable template"
                    data-testid={`save-template-${item.id}`}
                    style={{ ...ICON_BTN_STYLE, color: '#FFD700' }}
                  >
                    <FileText size={14} />
                  </button>
                  <button
                    type="button"
                    onClick={(e) => onDelete(item.id, item.subject, e)}
                    title="Delete from history"
                    data-testid={`delete-email-history-${item.id}`}
                    style={{ ...ICON_BTN_STYLE, color: '#ef4444' }}
                  >
                    <Trash2 size={14} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);

export default EmailHistoryCard;
